/*
 * SimplePageTitle.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Thu Mar 02 2023 mys Company
 */

import polganPNG from '../../assets/icons/Polygon.png'

const SimplePageTitle = ({ title }) => {
    return (
        <>
            <h1 className="font-bold ">
                <img src={polganPNG} alt={title} className="inline-block h-2" />
                <span className="inline-block pr-2">{title}</span>
            </h1>
        </>
    )
}

export default SimplePageTitle
